import axios from 'axios'

export default {
    get: () => axios.get('bank_accounts'),
    list: () => axios.get('bank_accounts/list'),
    store: (data) => axios.post('bank_accounts/store', data),
    update: (data) => axios.post('bank_accounts/update', data),
    delete: (id) => axios.post('bank_accounts/delete', id)
}